import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarHiddenRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sidebar-hidden-right-wide"} maskId="square-filled-radius-0-stroke-1-IconSidebarHiddenRightWide"><path fillRule="evenodd" clipRule="evenodd" d="M2 20H22V4H2V20ZM19 7V17H18V7H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSidebarHiddenRightWide;
